import axios from "axios";

import { config } from "@/shared/config";

import {
  installAuthResponseInterceptor,
  installCsrfInterceptor,
} from "./authInterceptors";

/**
 * Один HTTP-клієнт на весь застосунок (ADR-0003 D5).
 *
 * `baseURL: config.apiBaseUrl` — дефолт `/api` (same-origin: у деві проксується
 * Vite на Go :8080, у проді віддається з того ж бінарника, ADR-0003 D4),
 * override через `VITE_API_BASE_URL` (напр. ізольовані e2e-стенди).
 * `withCredentials: true` — щоб майбутня HttpOnly session-cookie (ADR-0002)
 * долітала без CORS-узгоджень.
 *
 * CSRF request-interceptor навішується тут (ADR-0006 D3, ітер.1): self-contained
 * у `shared` — ехоїть cookie `csrf` у `X-CSRF-Token` на мутаціях. 401 response-
 * interceptor через seam у `app/` — ітер.2 (ADR-0006 D4).
 */
export const httpClient = axios.create({
  baseURL: config.apiBaseUrl,
  withCredentials: true,
  timeout: 15_000,
  headers: { Accept: "application/json" },
});

installCsrfInterceptor(httpClient);

/**
 * Response-interceptor (ADR-0010 D4): нормалізує КОЖЕН reject у `AppError` і
 * виконує 401-редірект через seam. `app/providers` реєструє конкретний handler
 * (`setUnauthorizedHandler`) у feature-007 ітер.2 — до того seam дрімає (no-op).
 */
installAuthResponseInterceptor(httpClient);
